module.exports = __webpack_public_path__ + "static/4-4cbb9f1bf9bca5bfd2767b38b2bac428.jpeg";